import { render } from "./OrdersView.vue?vue&type=template&id=e3be71d2&ts=true"
import script from "./OrdersView.vue?vue&type=script&lang=ts"
export * from "./OrdersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__